import { memo } from 'react';

export const UlList = memo(({ bullets, className }) => (
	<ul className={className}>
		{bullets
			.split('*')
			.filter(v => v)
			.map(bullet => (
				<li key={bullet}>{bullet}</li>
			))}
	</ul>
));

const LOCAL_STORAGE_AVAILABLE = (() => {
	try {
		const storage = window.localStorage;
		const x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return false;
	}
})();
const KEY = 'chat-terms-accepted';

export const getChatTermsAccepted = () => {
	if (LOCAL_STORAGE_AVAILABLE) {
		return window.localStorage.getItem(KEY) === 'true';
	}
	const ls = window.__LOCALSTORAGE_FAKE__ || {};
	return ls[KEY] === 'true';
};

export const storeChatTermsAccepted = () => {
	if (LOCAL_STORAGE_AVAILABLE) {
		window.localStorage.setItem(KEY, 'true');
	} else {
		const ls = window.__LOCALSTORAGE_FAKE__ || {};
		window.__LOCALSTORAGE_FAKE__ = { ...ls, [KEY]: 'true' };
	}
};
